module.exports = __webpack_public_path__ + "img/電気回路_5_5_2.a8609045.png";